import { isNotEmpty, useForm } from '@mantine/form'
import { modals } from '@mantine/modals'
import { handleMutationError } from '@v2/commons/utils/errorHandling/handleMutationError'
import { showSuccessNotification } from '@v2/domains/notification/notification.hook'

import { useCreateTagMutation } from '../api/tag.api'
import type { TagCreateMutationData } from '../tag.types'

const useCreateTag = () => {
  const [createTagMutation, { status }] = useCreateTagMutation()

  const rowValuesForm = useForm<TagCreateMutationData>({
    initialValues: {
      name: '',
      isProtected: false,
      isHided: false,
      isNotEligible: false,
      color: '#f4f5f7',
    },
    mode: 'uncontrolled',
    validate: {
      name: isNotEmpty('name is mandatory'),
    },
    validateInputOnBlur: true,
  })

  const createTag = async (): Promise<boolean> => {
    try {
      await createTagMutation({ data: rowValuesForm.getValues() }).unwrap()
      showSuccessNotification('Tag succesfuly Created!')
      modals.closeAll()
      return true
    } catch (err: any) {
      handleMutationError(err, 'Error Creating Tag')
      return false
    }
  }

  return {
    createTag,
    createMutationStatus: status,
    rowValuesForm,
  }
}

export default useCreateTag
